const localStorageKey = 'gameData'

export const getCurrentGameData = () => {
    return localStorage.getItem(localStorageKey) !== null ? JSON.parse(localStorage.getItem(localStorageKey)) : {};
}

export const setCurrentGameData = (boardNumber, propertyName, propertyValue) => {
    const game_data = getCurrentGameData();
    if (!game_data[boardNumber]) {
        game_data[boardNumber] = {};
    }
    game_data[boardNumber][propertyName] = propertyValue

    localStorage.setItem(localStorageKey, JSON.stringify(game_data));
}

export const getGameDataProperty = (boardNumber, propertyName) => {
    const game_data = getCurrentGameData();
    return boardNumber in game_data && propertyName in game_data[boardNumber] ? game_data[boardNumber][propertyName] : null
}

// Only real, numbered boards count here - e.g. the tutorial's result is stored
// under the non-numeric key 'tutorial', which must never be mistaken for a real
// played day by streak/archive logic.
export const getPlayedBoardNumbers = () => Object.entries(getCurrentGameData())
    .filter(([key, data]) => Number.isInteger(Number(key)) && data?.gameScore !== null && data?.gameScore !== undefined)
    .map(([number]) => Number(number));

// Boards release one per day, so board numbers double as a day index: the player's
// streak is just how many consecutive board numbers (counting back from today) have
// a recorded score. If today's board isn't finished yet, count back from yesterday
// instead so an in-progress day doesn't zero out a streak that's still alive. Returns
// the board numbers that make up that run, e.g. for highlighting them in an archive list.
export const getActiveStreakBoards = (latestBoardNumber) => {
    const latest = Number(latestBoardNumber);
    if (!Number.isInteger(latest) || latest < 1) return [];

    const playedBoards = new Set(getPlayedBoardNumbers());
    let boardNum = playedBoards.has(latest) ? latest : latest - 1;
    const streakBoards = [];
    while (boardNum >= 1 && playedBoards.has(boardNum)) {
        streakBoards.push(boardNum);
        boardNum--;
    }
    return streakBoards;
};

export const getPlayStreak = (latestBoardNumber) => getActiveStreakBoards(latestBoardNumber).length;

// Longest run of consecutive completed board numbers ever, not just the one still
// active today - i.e. a high-water mark that survives even after a streak breaks.
export const getBestStreak = () => {
    const playedBoards = [...new Set(getPlayedBoardNumbers())].sort((a, b) => a - b);

    let best = 0;
    let current = 0;
    let previous = null;
    playedBoards.forEach((boardNum) => {
        current = (previous !== null && boardNum === previous + 1) ? current + 1 : 1;
        best = Math.max(best, current);
        previous = boardNum;
    });
    return best;
};